import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import map from '../Assets/Images/map.png'
import { useTheme } from '@mui/material/styles';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import { post } from '../Services/api-services';
import { Box, ThemeProvider } from '@mui/system';
import Heatmap from '../Components/Heatmap';




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function StudentMap() {

    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const [askedData, setAskedData] = React.useState({})


    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const heatMapDatabyStudentApi = async () => {
        const res = await post('/doubts/heatmapData')
        if (res?.statusCode === 200) {
            setAskedData(res?.data)
        }
    }
    React.useEffect(() => {
        heatMapDatabyStudentApi()
    }, [])
    return (
        <React.Fragment>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
            Open dialog
         </Button> */}
            {/* <div className='bg-[#E2E2E2]  cursor-pointer '>
                     <FilterAltIcon onClick={handleClickOpen} sx={{color:'#98D2C5', width:35, marginTop:1}} />
                </div> */}
            <div className='flex gap-2 items-center cursor-pointer bg-[#EAF2F0] border border-[#E2E2E2] p-1 px-3 text-[#FFFFFF]' onClick={handleClickOpen}>
                <img src={map} alt='map' width={35} />

            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth='sm'
                fullWidth
                sx={{
                    overflow: 'hidden'
                }}
                aria-labelledby="responsive-dialog-title"
                BackdropProps={{ invisible: true }}
            >
                <div style={{ backgroundColor: theme.palette.bg.dialog }} className='w-full  '>

                    <DialogTitle
                        sx={{

                            backgroundColor: theme.palette.bg.secondary,
                            color: theme.palette.headings.main,
                            borderBottom: `1px solid ${theme.palette.searchBorder.main}`,

                        }}
                        id="customized-dialog-title">
                        Time Slab-Most Asked Doubts
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers className='justify-center flex flex-col gap-16 mx-16'>
                        <div className='  flex  gap-4 justify-center'>
                            <div >
                                <Typography style={{ color: theme.palette.headings.main, }} className=' font-semibold' sx={{ fontSize: 12 }}>Most doubt asked</Typography>
                                <Box className='bg-[#7BB5A8] rounded' width={28} height={11}></Box>
                            </div>
                            <div>
                                <Typography style={{ color: theme.palette.headings.main, }} className=' font-semibold' sx={{ fontSize: 12 }}>Less doubt asked</Typography>
                                <Box className='bg-[#7BB5A88A] rounded' width={28} height={11}></Box>
                            </div>
                            <div>
                                <Typography style={{ color: theme.palette.headings.main, }} className=' font-semibold' sx={{ fontSize: 12 }}>Very-Less doubt asked</Typography>
                                <Box className='bg-[#7BB5A824] rounded' width={28} height={11}></Box>

                            </div>
                        </div>
                        <Heatmap
                            orientation="vertical"
                            data={askedData.hourlyDoubtOfEveryDay}
                            xAxisLabels={askedData.dateArray}
                            yAxisLabels={askedData.hoursArray}
                        />

                    </DialogContent>
                </div>
            </Dialog>
        </React.Fragment>
    );
}